import React from 'react';
import { Helmet } from 'react-helmet';
import DateFnsUtils from '@date-io/date-fns';
import { THEMES } from './constants';
import { HashRouter as _HashRouter, HashRouterProps } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { ThemeProvider } from 'styled-components/macro';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import {StylesProviderProps} from '@material-ui/styles'
import { StylesProvider as _StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';

import createTheme from './theme';
import { AppRoutes } from './AppRoutes';

import 'react-toastify/dist/ReactToastify.css';

function App() {
  const theme = THEMES.DEFAULT;
  /* Workaround for compilation issue - see https://github.com/stripe/stripe-react-native/issues/678 */
  const StylesProvider = _StylesProvider as React.FC<StylesProviderProps>;
  const HashRouter = _HashRouter as unknown as React.FC<HashRouterProps>;
  return (
    <React.Fragment>
      <Helmet titleTemplate="Backoffice" defaultTitle="Backoffice Admin" />
  <StylesProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <MuiThemeProvider theme={createTheme(theme)}>
            <ThemeProvider theme={createTheme(theme)}>
              <HashRouter>
                <AppRoutes />
                <ToastContainer />
              </HashRouter>
            </ThemeProvider>
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </React.Fragment>
  );
}

export default App;
